export default function getAvpStageLink(carlineId: string | undefined, modelYear: number | undefined) {
	if (carlineId?.startsWith('q6') || carlineId?.startsWith('sq6')) {
		return 'a-ngc-q6etron-my2025';
	}
	if (carlineId?.startsWith('a5') || carlineId?.startsWith('s5') || carlineId?.startsWith('rs5')) {
		return 'a-ngc-a5-my2025';
	}
	if (carlineId?.startsWith('etron') || carlineId?.startsWith('setron') || carlineId?.startsWith('rsetron')) {
		return 'a-ngc-etrongt-my2025';
	}
	if (
		carlineId?.startsWith('a6avantetron') ||
		carlineId?.startsWith('s6avantetron') ||
		carlineId?.startsWith('a6sbetron') ||
		carlineId?.startsWith('s6sbetron')
	) {
		return 'a-ngc-a6etron-my2025';
	}
	if (
		(carlineId?.startsWith('a6') || carlineId?.startsWith('s6') || carlineId?.startsWith('rs6')) &&
		modelYear &&
		modelYear >= 2026
	) {
		return 'a-ngc-AU59x-a6-my2026';
	}
	if (carlineId?.startsWith('a3') || carlineId?.startsWith('s3') || carlineId?.startsWith('rs3')) {
		return 'a-ngc-a3-my2025';
	}
	if (
		carlineId?.startsWith('q4etron') ||
		carlineId?.startsWith('sq4etron') ||
		carlineId?.startsWith('q4sbetron') ||
		carlineId?.startsWith('sq4sbetron')
	) {
		return 'a-ngc-q4etron-my2025';
	}
	if (
		carlineId?.startsWith('q8etron') ||
		carlineId?.startsWith('sq8etron') ||
		carlineId?.startsWith('q8sbetron') ||
		carlineId?.startsWith('sq8sbetron')
	) {
		return 'a-ngc-q8etron-my2025';
	}
	if (carlineId?.startsWith('q5') || carlineId?.startsWith('sq5')) {
		return 'a-ngc-q5-my2025';
	}
	// if (carlineId?.startsWith('a1')) {
	// 	return 'a-ngc-a1-my2025';
	// }
	// if (carlineId?.startsWith('a7') || carlineId?.startsWith('s7') || carlineId?.startsWith('rs7')) {
	// 	return 'a-ngc-a7-my2025';
	// }
	// if (carlineId?.startsWith('a8') || carlineId?.startsWith('s8')) {
	// 	return 'a-ngc-a8-my2025';
	// }
	// if (carlineId?.startsWith('q3') || carlineId?.startsWith('rsq3')) {
	// 	return 'a-ngc-q3-my2025';
	// }
	// if (carlineId?.startsWith('q7') || carlineId?.startsWith('sq7')) {
	// 	return 'a-ngc-q7-my2025';
	// }
	// q8 has to be after q8etron to work correctly
	// if (carlineId?.startsWith('q8') || carlineId?.startsWith('sq8') || carlineId?.startsWith('rsq8')) {
	// 	return 'a-ngc-q8-my2025';
	// }

	return 'a-ngc-default-my2025';
}
